import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class UserManagementService {
	constructor(private httpClient: HttpClient) {}

	login(userDetails) {
		return this.httpClient.post(environment.apiUrl + '/login', userDetails);
	}

	fetchRolePermissionDetails(roleDetails) {
		return this.httpClient.post(environment.apiUrl + '/fetchRolePermissionDetails', roleDetails);
	}

	setRoleMenuPermissionDetails(mappedRoleMenuDetails) {
		return this.httpClient.post(environment.apiUrl + '/setRoleMenuPermissionDetails', mappedRoleMenuDetails);
	}

	fetchBirthdayDetailsOfUser() {
		return this.httpClient.get(environment.apiUrl + '/fetchBirthdayDetailsOfUser');
	}
	updatePassword(userDetails){
		return this.httpClient.post(environment.apiUrl + '/updatePassword', userDetails);

	}
}
